import { Api } from "../config/request";

export default {
  getRiderPayouts(queryParams) {
    return Api.get(`/driver-accounting/driver-payout-history${queryParams}`);
  },
};
